import React from 'react';

import CoastKeyMapper from '../components/FieldNoms/BeachSwaps/CoastKeyMapper';
import TerminalMapping from '../components/FieldNoms/FieldNomination/TerminalMapping';
import SwingContractMapping from '../components/FieldNoms/SwingContracts/ZKeyMapping';
import Audit from '../pages/Audit';
import Cva from '../pages/Cva';
import Dashboard from '../pages/Dashboard';
import FieldNoms from '../pages/FieldNoms';
import Gemini from '../pages/Gemini';
import Maintenance from '../pages/Maintenance';
import Nominations from '../pages/Nominations';
import RoleAndPermissions from '../pages/RoleAndPermissions';
import SenseCheck from '../pages/SenseCheck';
import SummaryReports from '../pages/SummaryReports';
import Trading from '../pages/Trading';
import UserAndRoles from '../pages/UserAndRoles';
import IAppRoute from './AppRoute.type';
import routepaths from './routepaths';
import DANomsAuditLogs from '../components/FieldNoms/FieldNomination/DANomsAuditLogs';

const GenesisRoutes: IAppRoute[] = [
  // Genesis routes (existing structure)
  { path: routepaths.dashboard, element: <Dashboard /> },
  { path: routepaths.activity, element: <Maintenance /> },
  { path: routepaths.maintenance, element: <Maintenance /> },
  { path: routepaths.locations, element: <Maintenance /> },
  { path: routepaths.gemini, element: <Gemini /> },
  { path: routepaths.userAndRoles, element: <UserAndRoles /> },
  { path: routepaths.addRoleAndPermissions, element: <RoleAndPermissions /> },
  {
    path: routepaths.modifyRoleAndPermissions,
    element: <RoleAndPermissions />,
  },
  { path: routepaths.nominations, element: <Nominations /> },
  { path: routepaths.nominationsHistory, element: <Nominations /> },
  { path: routepaths.trade, element: <Trading /> },
  { path: routepaths.audit, element: <Audit /> },
  { path: routepaths.senseCheck, element: <SenseCheck /> },
  { path: routepaths.cva, element: <Cva /> },
  { path: routepaths.summaryReports, element: <SummaryReports /> },
  { path: routepaths.fieldNoms, element: <FieldNoms /> },
  { path: routepaths.terminalMapping, element: <TerminalMapping /> },
  { path: routepaths.daNoms, element: <DANomsAuditLogs /> },
  { path: routepaths.coastKeyMapper, element: <CoastKeyMapper /> },
  { path: routepaths.swingContractMapping, element: <SwingContractMapping /> },
];

export default GenesisRoutes;
